import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import logo2 from "../../assets/logodark.png";
import ig from "../../assets/ig-icon.svg";
import fb from "../../assets/fb-icon.svg";
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

function Footer() {
  const { language } = useContext(LanguageContext);
  const t = language === "no" ? no.footer : en.footer;

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className="wrap">
          <div className={styles.content_flex}>
            <div className={styles.footer_card}>
              <h4 className={styles.heading}>{t.contactUs}</h4>
              <p>post@instantiris.no</p>
              <p>Steinkjellergaten 2, 5003 Bergen</p>
            </div>

            <div className={styles.footer_card}>
              <h4 className={styles.heading}>{t.openingHours}</h4>
              <p className={styles.note}>
                <strong>{t.bookingRequired}</strong>
              </p>
              <p>{t.wednesday}</p>
              <p>{t.thursday}</p>
              <p>{t.saturday}</p>
            </div>

            <div className={styles.brand_row}>
              <div className={styles.icon_wrap}>
                <a
                  href="https://www.instagram.com/instant.iris/"
                  aria-label="Instagram"
                >
                  <img className={styles.icon} src={ig} alt="" />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61551954833049"
                  aria-label="Facebook"
                >
                  <img className={styles.icon} src={fb} alt="" />
                </a>
              </div>

              <div className={styles.logo}>
                <Link to="/">
                  <img src={logo2} alt="Instant Iris" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
